import { inject, Injectable } from '@angular/core';
import { EntityDetailStore } from '@webapp/core/stores/entity-detail-store.service';
import { IUserDetail, UserStatusValue } from '@webapp/users/interfaces/users.interface';
import { UsersService } from '@webapp/users/services/users.service';
// Deep import (NOT the `@webapp/users` barrel): the barrel re-exports
// routes.ts, which eagerly loads UsersPageComponent/CreateAdminPageComponent
// and would pull the whole users page graph into the prospects chunk — see
// design D3.
import { UserStatusService } from '@webapp/users/services/user-status.service';
import { firstValueFrom, map } from 'rxjs';
import { buildStatus } from '@webapp/users/common/map';

@Injectable({
	providedIn: 'root',
})
export class ProspectsStoreService {
	detailStore: EntityDetailStore<IUserDetail>;
	service = inject(UsersService);
	private readonly userStatusService = inject(UserStatusService);

	constructor() {
		this.detailStore = new EntityDetailStore<IUserDetail>((id: string) =>
			firstValueFrom(
				this.service.getProspectById(id).pipe(
					map(res =>
						res
							? ({
									...res,
									...buildStatus(res),
								} as unknown as IUserDetail)
							: null
					)
				)
			)
		);
	}

	public get() {
		return this.detailStore.getSelected();
	}

	async changeUserStatus(id: string, status: UserStatusValue) {
		const success = await this.userStatusService.changeStatus(id, status);
		if (success) {
			await this.detailStore.fetch(id);
		}
	}
}
